import styles from '../../styles/admin/MainContent.module.scss'
import { CurriculumProps } from '../../types/table'
import Table from '../common/Table'
import VimeoEmbed from '../common/VimeoEnbed'
import CurriculumVideoHeader from './CurriculumVideoHeader'
import CurriculumVideoItem from './CurriculumVideoItem'

export interface VideoDataProps {
  videoID: React.ReactNode
  hash: React.ReactNode
  vimeoId?: string
  hashKey?: string
  title?: string
  videoTitle?: React.ReactNode
  actions?: React.ReactNode
  depth?: React.ReactNode
}

interface ResultContentProps {
  curriculum: CurriculumProps[]
  videoData: VideoDataProps[]
  showPreview?: boolean
  showSubject?: boolean
  saveButton?: React.ReactNode
  previewRowIndex?: number
  onAddRow?: () => void
}

const ResultContent = ({
  curriculum,
  videoData,
  showPreview = false,
  showSubject = true,
  saveButton,
  previewRowIndex = 0,
  onAddRow,
}: ResultContentProps) => {
  const previewData = videoData[previewRowIndex] ?? videoData[0]
  const hasDepthCol = videoData.some((v) => v.depth !== undefined)

  return (
    <div
      className={styles.resultContentContainer}
      style={{
        backgroundColor: '#ffff',
        borderRadius: '15px',
        padding: '20px',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.12)',
      }}
    >
      {showSubject && (
        <>
          <h3 className={styles.contentTitle}>Subject</h3>
          <Table className={styles.tableWrapper}>
            <thead>
              <CurriculumVideoHeader />
            </thead>
            <tbody>
              {curriculum.length > 0 ? (
                curriculum.map((curriculumItem, index) => (
                  <CurriculumVideoItem key={index} curriculum={curriculumItem} index={index} />
                ))
              ) : (
                <tr>
                  <Table.Cell colSpan={6}>
                    <Table.Empty>No curriculum data available.</Table.Empty>
                  </Table.Cell>
                </tr>
              )}
            </tbody>
          </Table>
        </>
      )}

      <div style={{ display: 'flex', gap: '24px', alignItems: 'flex-start', marginTop: showSubject ? '16px' : '0' }}>
        <div style={{ flex: 1, minWidth: 0 }}>
          <Table className={styles.videoTable}>
            <thead>
              <tr>
                <th style={{ width: '32px' }}>#</th>
                {hasDepthCol && <Table.Header>Depth</Table.Header>}
                <Table.Header>Video Title</Table.Header>
                <Table.Header>Vimeo Link / ID</Table.Header>
                <Table.Header>Hash Key</Table.Header>
                <th style={{ width: '40px' }}></th>
              </tr>
            </thead>
            <tbody>
              {videoData.length > 0 ? (
                videoData.map((video, index) => (
                  <tr key={index}>
                    <td style={{ textAlign: 'center', color: '#6b7280', fontSize: '13px', padding: '8px' }}>
                      {index + 1}
                    </td>
                    {hasDepthCol && <Table.Cell>{video.depth}</Table.Cell>}
                    <Table.Cell>{video.videoTitle}</Table.Cell>
                    <Table.Cell>{video.videoID}</Table.Cell>
                    <Table.Cell>{video.hash}</Table.Cell>
                    <td style={{ textAlign: 'center', padding: '8px' }}>{video.actions}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <Table.Cell colSpan={hasDepthCol ? 6 : 5}>
                    <Table.Empty>No video.</Table.Empty>
                  </Table.Cell>
                </tr>
              )}
            </tbody>
          </Table>

          {onAddRow && (
            <button
              type="button"
              onClick={onAddRow}
              style={{
                marginTop: '8px',
                padding: '6px 16px',
                fontSize: '13px',
                color: '#425AA8',
                background: 'none',
                border: '1px dashed #425AA8',
                borderRadius: '6px',
                cursor: 'pointer',
              }}
            >
              + Add Row
            </button>
          )}

          {saveButton}
        </div>

        {showPreview && (
          <div style={{ width: '320px', flexShrink: 0 }}>
            <p style={{ fontSize: '13px', fontWeight: 600, color: '#0D2A4F', marginBottom: '8px' }}>
              Video Preview
            </p>
            <VimeoEmbed
              vimeoId={previewData?.vimeoId || ''}
              hash={previewData?.hashKey || ''}
              title={previewData?.title || 'Video Preview'}
            />
          </div>
        )}
      </div>
    </div>
  )
}

export default ResultContent
